angular.module('unica_survey.survey_services')

.factory('SurveyCreateService', function ($http, getBaseApiURL) {

	var surveyCreateService = {};

	surveyCreateService.create = function (surveyData)
	{
		return $http({
			method: 'post',
			url: getBaseApiURL + '/survey/create',
			data: surveyData
		}).then(function(result) {

			if ( result ) {
				return result.data.survey;
			}

		});
	};

	return surveyCreateService;
});